import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, map, take } from 'rxjs';

import { IBetslipRootState } from '../../../../../base/store/state';
import { betslipSelectedTypeStateSelector } from '../../../../types/selectors';
import { BetslipError } from '../../../errors/betslip-error';
import { EditBetEarlyPayoutChangedPreCheckError } from '../../../errors/pre-check/edit-bet-early-payout-changed-pre-check-error';
import BetslipErrorsUtilsService from '../../utils/betslip-errors-utils.service';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class EditBetEarlyPayoutChangedMessageFormatter extends MessageFormatter<EditBetEarlyPayoutChangedPreCheckError> {
    constructor(
        private betslipErrorUtils: BetslipErrorsUtilsService,
        private store: Store<IBetslipRootState>,
    ) {
        super();
    }

    format(error: EditBetEarlyPayoutChangedPreCheckError): Observable<string> {
        return this.store.select(betslipSelectedTypeStateSelector).pipe(
            map((selectedType) => this.betslipErrorUtils.getToastNotification([error], selectedType).message),
            take(1),
        );
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof EditBetEarlyPayoutChangedPreCheckError;
    }
}
